// pgw 07-dec-2025 includes changes

import React from 'react';
import { MixBoard, ChoirConductor, Modal, Input, Button } from "player-components";
import audioEngine from "../../services/audioEngine";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTour, TourProvider } from "@reactour/tour";
import formatDuration from 'date-fns/formatDuration'

import {
  selectStatus,
  selectStems,
  selectUserStems,
  unmuteChannel,
  muteChannel,
  removeChannelAsync,
  soloChannel,
  unsoloChannel,
  selectLoadedSong,
  selectSpeed,
  selectDuration,
  selectPitch,
  changeChannelGain,
  changeChannelPan,
  selectLoadingProgress,
  selectIsSafari,
  selectIsFirefox,
  addNewStem,
  disarmChannel,
  armChannel,
  attachUserMicrophoneAsync,
  mountSessionAsync,
  stopSong,
  packSessionAsync,
  mountSessionAndRenderOfflineAsync,
  selectSession,
  resetSessionMixerSettings,
  selectIntroLevel,
  selectClick1Level,
  selectClick2Level,
  selectCueLevel,
  setIntroLevel,
  setClick1Level,
  setClick2Level,
  setCueLevel,
  openSession,
  unmountSessionAsync
} from "../../features/session/sessionSlice";

import {fetchLyricsAsync, selectLyricsStatus} from '../../features/lyrics/lyricsSlice'

import LoadingScreen from "../../components/LoadingScreen";
import {
  saveExistingSession,
  selectSetlistSessions,
  resetLastCreated
} from "../../features/setlist/setlistSlice";
import NoSessionLoaded from "../../components/NoSessionLoaded";
import { ExclamationIcon, MicrophoneIcon } from "@heroicons/react/outline";
import {
  addNotificationAsync,
  selectNewTrackModalVisible,
  setNewTrackModalVisible,
  selectClientConfig,
  selectShowLyrics,
  setShowLyrics,
  setUserInputtingText,
  selectSoloMode,
  setSoloMode,
  setOfflineModalVisible,
} from "../../features/ui/uiSlice";

import {
  selectLyricsLyrics
} from "../../features/lyrics/lyricsSlice";
import { useNavigate } from "react-router-dom";

// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';

let mountedOnce = false;

const TourGuideContainer = ({title, text}) => {

  return <div className="flex flex-col justify-center align-middle">
    <h3 className="text-lg font-bold mb-2 text-primary">{title}</h3>
    <p>{text}</p>
    {/* <Button style={{width: 100}}>Close</Button> */}
    </div>

}

const steps = [
  {
    selector: ".stem",
    content: <TourGuideContainer
      title="Song stem"
      text="This is the stem content. You can change the volume of each part by tapping the group. As you turn down the stem, it will fade out to grey."
    />,
  },
  {
    selector: "#transport",
    content: <TourGuideContainer
      title="Playback controls"
      text="Use these to control playback of the song"
    />,
  },
  {
    selector: "#section-button",
    content: <TourGuideContainer
      title="Song sections"
      text="Skip between different song sectios with this button"
    />,
  },
  {
    selector: "#solo-button",
    content: <TourGuideContainer
    title="Playback controls"
    text="Clicking this will enable solo mode, which allows you to listen to just one part at a time. Click the section you'd like to solo"
  />
  },
  {
    selector: "#lyrics-button",
    content: <TourGuideContainer
    title="Show/Hide Lyrics"
    text="View the songs lyrics while you listen to the song."
  />,
  },
  {
    selector: "#pitch-speed-button",
    content: <TourGuideContainer
    title="Speed/Pitch"
    text="You can change the speed and pitch of the playback independently"
  />,
  },
  {
    selector: "#reset-button",
    content: <TourGuideContainer
    title="Reset mix"
    text="If you'd like to reset everything back to the original settings, then tap reset!"
  />,
  },
  
  
  
];


const Session = () => {
  const dispatch = useDispatch();
  const {setSteps, setIsOpen} = useTour();
  // const session = useSelector(selectSession);
  // const sessions = useSelector(selectSession);
  const status = useSelector(selectStatus);
  const stems = useSelector(selectStems);
  const userStems = useSelector(selectUserStems);
  const duration = useSelector(selectDuration);
  const loadingProgress = useSelector(selectLoadingProgress);
  const soloMode = useSelector(selectSoloMode);

  const introLevel = useSelector(selectIntroLevel);
  const click1Level = useSelector(selectClick1Level);
  const click2Level = useSelector(selectClick2Level);
  const cueLevel = useSelector(selectCueLevel);

  const setlistSessions = useSelector(selectSetlistSessions);

  const newTrackModalVisible = useSelector(selectNewTrackModalVisible);

  const clientConfiguration = useSelector(selectClientConfig);

  const currentLyrics = useSelector(selectLyricsLyrics);

  const showLyrics = useSelector(selectShowLyrics);
  const lyricsStatus = useSelector(selectLyricsStatus);

  const [pendingNewChannel, setPendingNewChannel] = useState(false);
  const [lrcLyrics, setLrcLyrics] = useState(null);
  const [pendingNewChannelName, setPendingNewChannelName] = useState("");
  const [pendingDeleteChannel, setPendingDeleteChannel] = useState(false);

  const [showHeadphoneWarning, setShowHeadphoneWarning] = useState(false);
  const [showRecordArmWarning, setShowRecordArmWarning] = useState(false);

  const [currentTimeState, setCurrentTimeState] = useState(0);
  const navigate = useNavigate();


	const session = useSelector(state => state.session);

	useEffect(() => {
	  if (!session?.id) return;

	  console.log("[SESSION DEBUG] after open (redux)", {
		id: session.id,
		speed: session.speed,
		pitch: session.pitch,
		stems: session.stems?.map(s => ({ id: s.id, level: s.level, muted: s.muted, soloed: s.soloed }))
	  });
	}, [session?.id]);





	useEffect(() => {
	  if (!session?.id) return;

	  console.log("[SESSION PAGE] session opened", {
		id: session.id,
		songId: session.song?.songId,
		origin: session.origin,
		stems: session.stems?.map(s => ({
		  id: s.id,
		  level: s.level,
		  muted: s.muted,
		  soloed: s.soloed
		}))
	  });
	}, [session?.id]);



	// pgw 26-jan-2026
	useEffect(() => {
	  console.log("[CONTAINERS_SESSION_INDEX] stems now", stems.map(s => ({id:s.id, level:s.level})));
	}, [stems]);


  useEffect(()=> {
    if (session.song?.lyricsUrl && !lrcLyrics && (lyricsStatus !== 'pending')) dispatch(fetchLyricsAsync(session.song.lyricsUrl));
  }, [dispatch, lrcLyrics, session])


  // pgw 20-jan-2026
  // Run this block of code every time status changes
  // So nothing inside here runs on every render — only when status gets a new value.
  useEffect(() => {

		// pgw testing 19-jan-2025
        debugLog('pgw player-application/src/containers/Session/index.js pgw2_5 - p1');
		debugLog("pgw2_5 - p2, status = ", status);
		

		// debugLog(status);


      if (status === 'ready') {
        if (localStorage) {
          if (!localStorage.getItem('show_session_tour_guide')) {

			// pgw 19-jun-2025 - do not show tour guide for now...
// 			localStorage.setItem('show_session_tour_guide', 'true');
//             setIsOpen(true);

            localStorage.setItem('show_session_tour_guide', 'false');
            setIsOpen(false);


          }
        }
      }


	  if (status === "unmounted" || (status !== "empty" && !mountedOnce)) {
		dispatch(stopSong());
		dispatch(mountSessionAsync({ cache: clientConfiguration.features.session.cacheOnMount }));
		dispatch(setSoloMode(false));

		// Only do this for truly empty sessions, not restored sessions
		if (status === "empty") {

		  console.log("[CONTAINERS_SESSION_INDEX] status is empty - calling turnUpAllStems" )

		  console.log("[SESSION] about to turnUpAllStems", {
			status,
			mountedOnce,
			stems: session?.stems?.map(s => ({ id: s.id, level: s.level }))
		  });

		  const isRestoredSession = !!session?.origin; // library or setlist
		  console.log("[CONTAINERS_SESSION_INDEX] status is empty -  isRestoredSession = " , isRestoredSession)

		  if (!isRestoredSession && status === "empty") {
		    console.log("[CONTAINERS_SESSION_INDEX] status is empty - calling turnUpAllStems " )
			turnUpAllStems();
		  }


		} else {
		  console.log("[SESSION] skipping turnUpAllStems; preserving restored mixer");
		}
	  }

	/*
      if (status === "unmounted" || (status !== "empty" && !mountedOnce)) {
        dispatch(stopSong());
        dispatch(mountSessionAsync({cache:clientConfiguration.features.session.cacheOnMount}));
        dispatch(setSoloMode(false));

		console.log("[CONTAINERS_SESSION_INDEX] useEffect status calling turnUpAllStems, status = " , status )
		console.log("[CONTAINERS_SESSION_INDEX] useEffect status calling turnUpAllStems, mountedOnce = " , mountedOnce )

		// pgw 26-jan-2026
		// I'm reasonably sure that this should not be called,
		// as I believe it overwrites custom settings for a song when it is loaded when the player starts
		// Remove it for now, then see what effect it has...
        // turnUpAllStems();
      }
	*/

      if (status === "error") {
		console.trace("error");
        dispatch(setOfflineModalVisible(true))
      }

      mountedOnce = true;
  }, [status]);

  useEffect(() => {
    
    setShowLyrics(false)
    dispatch(resetLastCreated());
    
    setLrcLyrics(null);
    // if (soloMode) {
    //   turnUpAllStems();
    //   dispatch(setSoloMode(false));
    // }
    

    setSteps(steps);
    
    return () => {
      setSteps([]);
      setIsOpen(false);
      dispatch(setShowLyrics(false));
      dispatch(stopSong());

	console.log("[CONTAINERS_SESSION_INDEX] useEffect return p1 session = ", session)

	// pgw 26-jan-2026
	// Remove this
	/*
      if (session.song?.mix) {
		console.log("[CONTAINERS_SESSION_INDEX] useEffect return p2 session.song?.mix = ", session.song?.mix)
		console.log("[CONTAINERS_SESSION_INDEX] useEffect return p3 before call to saveExistingSession !!!")
		dispatch(saveExistingSession(session));

	  }

	*/

    };
  }, []);


// pgw 24-jan-2026
// isInputChannel is defined and set only for channels that are used for recording.
// So, for now, ignore it
// Note that it is passed to changeChannelGain() as userStem
// In changeChannelGain, userstem is tested and, if not defined, the stem is found using the index argument
// In other words, userstem indicates it's a stem created by the user, which can be used for recording.

  const updateChannelGain = (channelId, value) => {
    const channel = stems
      .concat(userStems)
      .find((channel) => channelId === channel.id);
    dispatch(
      changeChannelGain({
        index: channel.index,
        value,
        userStem: channel.isInputChannel,
      })
    );

	// pgw 07-dec-2025

	console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - calling saveExistingSession, session = ", session)

	if (session.song?.mix) {
		console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - calling saveExistingSession, session.song?.mix = ", session.song?.mix)
		console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - calling saveExistingSession, session.song.mix = ", session.song.mix)

		// pgw 26-jan-2026
		/*
		if (session?.song?.mix?.includes("Test Song")) {
			console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain mix contains 'Test Song' - calling dispatch(saveExistingSession) ");
			dispatch(saveExistingSession({
			  ...session,
			  lastUpdatedAt: new Date().toISOString()
			}));
		} else {
		  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain mix does NOT contain 'Test Song'");
		}
		*/
	}
	else {
		console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - NOT calling saveExistingSession - no song " )
	}

  };


const updateChannelGainOld2 = (channelId, value) => {

  // pgw debug
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[0] = ", stems[0]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[1] = ", stems[1]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[2] = ", stems[2]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[3] = ", stems[3]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[4] = ", stems[4]);
// isInputChannel


  const channel = stems
    .concat(userStems)
    .find((channel) => channelId === channel.id);

  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - channel = ", channel);


  if (!channel) return;

  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - channel.isInputChannel = ", channel.isInputChannel);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - channel.channel.muted = ", channel.channel.muted);


  dispatch(
    changeChannelGain({
      index: channel.index,
      value,
      userStem: channel.isInputChannel,
    })
  );

  // Build next stems arrays for saving (session/stems are stale in this tick)
  const patch = (arr) =>
    arr.map((s) =>
      s.index === channel.index
        ? { ...s, level: value }
        : s
    );

  const nextStems = channel.isInputChannel ? stems : patch(stems);
  const nextUserStems = channel.isInputChannel ? patch(userStems) : userStems;

  const nextSession = {
    ...session,
    stems: nextStems,
    userStems: nextUserStems,
    lastUpdatedAt: new Date().toISOString(),
  };

  // pgw 07-dec-2025
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - saving nextSession", {
    channelId,
    index: channel.index,
    value,
  });

  if (session.song?.mix) {
    console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - session.song?.mix = ", session.song?.mix);

		// pgw 26-jan-2026
	/*
	
    if (session?.song?.mix?.includes("Test Song")) {
      console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain mix contains 'Test Song' - dispatch(saveExistingSession) ");
      dispatch(saveExistingSession(nextSession));
    } else {
      console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain mix does NOT contain 'Test Song'");
    }
	*/

  } else {
    console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - no song");
  }
};


// pgw 26-jan-2026
// Added dispatch(saveExistingSession(nextSession))

const updateChannelGainOld3 = (channelId, value) => {

  // pgw debug
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[0] = ", stems[0]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[1] = ", stems[1]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[2] = ", stems[2]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[3] = ", stems[3]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - stems[4] = ", stems[4]);

  const channel = stems.concat(userStems).find((c) => channelId === c.id);

  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - channel = ", channel);

  if (!channel) return;

  // ChoirPlayer: no input channels → always stems, never userStems
  dispatch(
    changeChannelGain({
      index: channel.index,
      value,
      userStem: false,
    })
  );

  // Build the next session snapshot (since session/stems are stale in this tick)
  const nextStems = stems.map((s) =>
    s.index === channel.index ? { ...s, level: value } : s
  );

  const nextSession = {
    ...session,
    stems: nextStems,
    lastUpdatedAt: new Date().toISOString(),
  };

  console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain - saving nextSession", {
    id: channel.id,
    index: channel.index,
    value,
  });
		// pgw 26-jan-2026
		/*

  if (session?.song?.mix?.includes("Test Song")) {
	console.log("[CONTAINERS_SESSION_INDEX] updateChannelGain mix contains 'Test Song' - calling dispatch(saveExistingSession) ");
    dispatch(saveExistingSession(nextSession));
  }

	*/
};




  const updateChannelPan = (channelId, value) => {
    const channel = stems
      .concat(userStems)
      .find((channel) => channelId === channel.id);
    dispatch(
      changeChannelPan({
        index: channel.index,
        value,
        userStem: channel.isInputChannel,
      })
    );
  };

  const updateChannelMuteOld = (channelId) => {
    const channel = stems
      .concat(userStems)
      .find((channel) => channelId === channel.id);
    dispatch(
      channel.muted
        ? unmuteChannel({
            index: channel.index,
            userStem: channel.isInputChannel,
          })
        : muteChannel({
            index: channel.index,
            userStem: channel.isInputChannel,
          })
    );

	// pgw 07-dec-2025
	console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - calling saveExistingSession, session = ", session)

	if (session.song?.mix) {
		console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - calling saveExistingSession, session.song?.mix = ", session.song?.mix)
		console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - calling saveExistingSession, session.song.mix = ", session.song.mix)

		// pgw 26-jan-2026
		/*
		if (session?.song?.mix?.includes("Test Song")) {
			console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute mix contains 'Test Song' - calling dispatch(saveExistingSession) ");
			dispatch(saveExistingSession({
			  ...session,
			  lastUpdatedAt: new Date().toISOString()
			}));
		} else {
		  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute mix does NOT contain 'Test Song'");
		}
		*/
	}
	else {
		console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - NOT calling saveExistingSession - no song " )
	}

  };



// If you paste the shape of one stem object (from console.log(stems[0])) and what isInputChannel actually means in your app, 
// I’ll adjust the patch to be 100% correct for your data model.

// pgw 26-jan-2026
// ChoirPlayer - doesn't seem to be called !!!
const updateChannelMute = (channelId) => {

  // pgw debug
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - stems[0] = ", stems[0]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - stems[1] = ", stems[1]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - stems[2] = ", stems[2]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - stems[3] = ", stems[3]);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - stems[4] = ", stems[4]);
// isInputChannel

  const channel = stems.concat(userStems).find((c) => channelId === c.id);

  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - channel = ", channel);

  if (!channel) return;


  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - channel.isInputChannel = ", channel.isInputChannel);
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - channel.channel.muted = ", channel.channel.muted);


  const nextMuted = !channel.muted;

  // 1) Update the audio/session slice as before
  dispatch(
    nextMuted
      ? muteChannel({ index: channel.index, userStem: channel.isInputChannel })
      : unmuteChannel({ index: channel.index, userStem: channel.isInputChannel })
  );

  // 2) ALSO build the *next* stems arrays for saving (because session in this tick is stale)
  const patch = (arr) =>
    arr.map((s) =>
      s.index === channel.index
        ? { ...s, muted: nextMuted }
        : s
    );

  const nextStems = channel.isInputChannel ? stems : patch(stems);
  const nextUserStems = channel.isInputChannel ? patch(userStems) : userStems;

  const nextSession = {
    ...session,
    stems: nextStems,
    userStems: nextUserStems,
    lastUpdatedAt: new Date().toISOString(),
  };

  // pgw debug
  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - saving nextSession muted change", {
    channelId,
    index: channel.index,
    nextMuted,
  });

  dispatch(saveExistingSession(nextSession));
};


  const updateChannelSolo = (channelId, solo) => {
    if (soloMode) {
      const channel = stems
      .concat(userStems)
      .find((channel) => channelId === channel.id);

      dispatch(
        changeChannelGain({
          index: channel.index,
          value: 1,
          userStem: channel.isInputChannel,
        })
      );


      // pgw 07-dec-2025
	  console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo - calling saveExistingSession 1, session = ", session)

	  if (session.song?.mix) {
		  console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo - calling saveExistingSession, session.song?.mix = ", session.song?.mix)
		  console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo - calling saveExistingSession, session.song.mix = ", session.song.mix)

		// pgw 26-jan-2026
		/*

		  if (session?.song?.mix?.includes("Test Song")) {
			  console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo mix contains 'Test Song' - calling dispatch(saveExistingSession) ");
			  dispatch(saveExistingSession({
				...session,
				lastUpdatedAt: new Date().toISOString()
			  }));
		  } else {
			console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo mix does NOT contain 'Test Song'");
		  }
		*/

	  }
	  else {
		  console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo - NOT calling saveExistingSession - no song " )
	  }

      const otherChannels = stems
      .concat(userStems)
      .filter((channel) => channelId !== channel.id);
      for (const otherChannel of otherChannels) {

        dispatch(
              changeChannelGain({
                index: otherChannel.index,
                value: 0,
                userStem: otherChannel.isInputChannel,
        }));



		if (session.song?.mix) {
			console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo - calling saveExistingSession 2, session.song?.mix = ", session.song?.mix)
			console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo - calling saveExistingSession2 , session.song.mix = ", session.song.mix)

		// pgw 26-jan-2026
		/*

			if (session?.song?.mix?.includes("Test Song")) {
				console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo mix contains 'Test Song' - calling dispatch(saveExistingSession) ");
				dispatch(saveExistingSession({
				  ...session,
				  lastUpdatedAt: new Date().toISOString()
				}));
			} else {
			  console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo mix does NOT contain 'Test Song'");
			}
		*/

		}
		else {
			console.log("[CONTAINERS_SESSION_INDEX] updateChannelSolo - NOT calling saveExistingSession - no song " )
		}

      }
    } else {
      const channel = stems
      .concat(userStems)
      .find((channel) => channelId === channel.id);
      dispatch(
        channel.soloed
          ? unsoloChannel({
              index: channel.index,
              userStem: channel.isInputChannel,
            })
          : soloChannel({
              index: channel.index,
              userStem: channel.isInputChannel,
            })
      );

	  // pgw 07-dec-2025
	  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - calling saveExistingSession, session = ", session)

	  if (session.song?.mix) {
		  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - calling saveExistingSession 2, session.song?.mix = ", session.song?.mix)
		  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - calling saveExistingSession2 , session.song.mix = ", session.song.mix)

		// pgw 26-jan-2026
		/*

		  if (session?.song?.mix?.includes("Test Song")) {
			  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute mix contains 'Test Song' - calling dispatch(saveExistingSession) ");
			  dispatch(saveExistingSession({
				...session,
				lastUpdatedAt: new Date().toISOString()
			  }));
		  } else {
			console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute mix does NOT contain 'Test Song'");
		  }

		*/
	  }
	  else {
		  console.log("[CONTAINERS_SESSION_INDEX] updateChannelMute - NOT calling saveExistingSession - no song " )
	  }



    }
  };

  const updateChannelArm = async (channelId) => {
    await dispatch(attachUserMicrophoneAsync());
    const channel = stems
      .concat(userStems)
      .find((channel) => channelId === channel.id);
    dispatch(
      channel.armed
        ? disarmChannel({
            index: channel.index,
            userStem: channel.isInputChannel,
          })
        : armChannel({
            index: channel.index,
            userStem: channel.isInputChannel,
          })
    );
  };

  const addStem = async () => {
    dispatch(setNewTrackModalVisible(true));
    dispatch(setNewTrackModalVisible(true));
  };

  const confirmAddStem = async () => {
    if (pendingNewChannelName) {
      await dispatch(attachUserMicrophoneAsync());
      dispatch(addNewStem({ name: pendingNewChannelName }));
      setPendingNewChannelName("");
      dispatch(setNewTrackModalVisible(false));

	  // pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
      /*
		dispatch(
        addNotificationAsync({
          title: "Track added to session",
          text: `${pendingNewChannelName} added to the session
        `,
          type: "positive",
        })
      );
		*/

    }
  };

  const shareSession = async () => {
    await dispatch(packSessionAsync());

    // pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
	/*
    dispatch(
      addNotificationAsync({
        title: "Session downloaded",
        text: `The session was packed up into a .session file and downloaded`,
        type: "positive",
      })
    );
	*/

  };

  const downloadSession = async () => {
    await dispatch(saveExistingSession(session));
    await dispatch(mountSessionAndRenderOfflineAsync({cache:clientConfiguration.features.session.cacheOnMount}));
	
	// pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
	/*
    dispatch(
      addNotificationAsync({
        title: "Session downloaded",
        text: `The session mix was bounced down and downloaded.`,
        type: "positive",
      })
    );
	*/

  };

  const resetSession = async () => {
    await dispatch(resetSessionMixerSettings());


    dispatch(
      addNotificationAsync({
        title: "Session reset",
        text: `All the mixer settings for the session were reset.`,
        type: "positive",
      })
    );

  };

  const deleteStem = async (channelId) => {
    const channel = stems
      .concat(userStems)
      .find((channel) => channelId === channel.id);
    if (channel.isInputChannel) {
      setPendingDeleteChannel(channel);
    }
  };

  const confirmDeleteTrack = async () => {
    await dispatch(removeChannelAsync(pendingDeleteChannel));
    setPendingDeleteChannel(false);
  };

  const handleCancel = async () => {
    await dispatch(unmountSessionAsync());
	// pgw 29-sep-2025
	debugLog('player-application/src/containers/Session/index.js handleCancel navigating to /library');
    navigate('/library');
    setTimeout(()=>window.location.reload(),100);
  }

  const formLrcLyrics = (lyricsArray) => {
    let lrcString = '';
    for (const line of lyricsArray) {
      lrcString = lrcString + `[${new Date(1000 * line.time).toISOString().substr(14, 8)}] ${line.text}\n`
    }
    return lrcString;
  }

  useEffect(()=>{
    if (currentLyrics) {
      setLrcLyrics(formLrcLyrics(currentLyrics));
    } else {
      setLrcLyrics(null)
    }
  },[currentLyrics])

  useEffect(()=>{
    const currentTimeInterval = setInterval(()=>{
      setCurrentTimeState(audioEngine.currentPosition);
    },100);
    return ()=>{
      
      
      dispatch(setSoloMode(false));
      // turnUpAllStems()
      clearInterval(currentTimeInterval)
    }
  },[])

  const turnDownAllStems = () => {
    for (const stem of stems.concat(userStems)) {

      dispatch(
        changeChannelGain({
          index: stem.index,
          value: 0,
          userStem: stem.isInputChannel,
        })
      );

	  // pgw 07-dec-2025
	  console.log("[CONTAINERS_SESSION_INDEX] turnDownAllStems - calling saveExistingSession, session = ", session)

	  if (session.song?.mix) {
		  console.log("[CONTAINERS_SESSION_INDEX] turnDownAllStems - calling saveExistingSession 2, session.song?.mix = ", session.song?.mix)
		  console.log("[CONTAINERS_SESSION_INDEX] turnDownAllStems - calling saveExistingSession2 , session.song.mix = ", session.song.mix)

		// pgw 26-jan-2026
		/*

		  if (session?.song?.mix?.includes("Test Song")) {
			  console.log("[CONTAINERS_SESSION_INDEX] turnDownAllStems mix contains 'Test Song' - calling dispatch(saveExistingSession) ");
			  dispatch(saveExistingSession({
				...session,
				lastUpdatedAt: new Date().toISOString()
			  }));
		  } else {
			console.log("[CONTAINERS_SESSION_INDEX] turnDownAllStems mix does NOT contain 'Test Song'");
		  }

		*/
	  }
	  else {
		  console.log("[CONTAINERS_SESSION_INDEX] turnDownAllStems - NOT calling saveExistingSession - no song " )
	  }


    }
  }

  const turnUpAllStems = () => {

// 	const hasCustomMix1 = session?.stems?.some(s => s.level !== 1 || s.muted || s.soloed);
// 	const hasCustomMix2 = session?.stems?.some(s => s.level !== 0.8 || s.muted || s.soloed);
// 	console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems, hasCustomMix1 = ", hasCustomMix1)
// 	console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems, hasCustomMix2 = ", hasCustomMix2)

	console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems, userStems = ", userStems)

    for (const stem of stems.concat(userStems)) {

      dispatch(
        changeChannelGain({
          index: stem.index,
          value: 1,
          userStem: stem.isInputChannel,
        })
      );




	  // pgw 07-dec-2025
	  console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems - calling saveExistingSession, session = ", session)


	  if (session.song?.mix) {
		  console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems - calling saveExistingSession 2, session.song?.mix = ", session.song?.mix)
		  console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems - calling saveExistingSession2 , session.song.mix = ", session.song.mix)

		// pgw 26-jan-2026
		/*

		  if (session?.song?.mix?.includes("Test Song")) {
			  console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems mix contains 'Test Song' - calling dispatch(saveExistingSession) ");
			  dispatch(saveExistingSession({
				...session,
				lastUpdatedAt: new Date().toISOString()
			  }));
		  } else {
			console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems mix does NOT contain 'Test Song'");
		  }
	*/

	  }
	  else {
		  console.log("[CONTAINERS_SESSION_INDEX] turnUpAllStems - NOT calling saveExistingSession - no song " )
	  }



    }
  }

  useEffect(()=>{
    if (soloMode) {
     
      //turn down level of all channels
      // turnDownAllStems()

		console.log("[CONTAINERS_SESSION_INDEX] useEffect soloMode is true - calling turnUpAllStems" )
		console.log("[SESSION] soloMode - about to turnUpAllStems");

      turnUpAllStems()
    } else {

		console.log("[CONTAINERS_SESSION_INDEX] useEffect soloMode is NOT true - doing nothing" )

      // setIsOpen(false);
      //unmute all channels
      // turnUpAllStems()
    }
  },[soloMode])

  const renderMixer = () => {
    switch (clientConfiguration.features.session.mixerTemplate) {
      case 'choir':
        return <ChoirConductor
          showMixRecord={clientConfiguration.features.session.showMixRecord}
          showMixControls={clientConfiguration.features.session.showMixControls}
          stems={stems.concat(userStems)}
          getVuLevel={audioEngine.getChannelPeak}
          onFaderChange={updateChannelGain}
          onPanChange={updateChannelPan}
          onMuteStem={updateChannelMute}
          onSoloStem={updateChannelSolo}
          onArmStem={updateChannelArm}
          onDeleteStem={deleteStem}
          onSave={(a, b, c) => {
            // debugLog(a, b, c);
          }}
          onAddStem={addStem}
          onDownload={downloadSession}
          onShare={shareSession}
          onReset={resetSession}
          onChangeIntroLevel={(newValue) => dispatch(setIntroLevel(newValue))}
          onChangeClick1Level={(newValue) => dispatch(setClick1Level(newValue))}
          onChangeClick2Level={(newValue) => dispatch(setClick2Level(newValue))}
          onChangeCueLevel={(newValue) => dispatch(setCueLevel(newValue))}
          // onSoloModeToggle={handleSoloModeToggle}
          step={0.5}
          showGuideChannelButtons={false}
          introLevel={introLevel}
          click1Level={click1Level}
          click2Level={click2Level}
          cueLevel={cueLevel}
          lyrics={lrcLyrics}
          currentTimeMilliseconds={currentTimeState}
          showLyricsButton={true}
          lyricsActive={showLyrics}
          onClickLyricsButton={()=>dispatch(setShowLyrics(!showLyrics))}
          soloMode={soloMode}
      />
        
      case 'band':
        return <MixBoard
          stems={stems.concat(userStems)}
          getVuLevel={audioEngine.getChannelPeak}
          onFaderChange={updateChannelGain}
          onPanChange={updateChannelPan}
          onMuteStem={updateChannelMute}
          onSoloStem={updateChannelSolo}
          onArmStem={updateChannelArm}
          onDeleteStem={deleteStem}
          onSave={(a, b, c) => {
            // debugLog(a, b, c);
          }}
          onAddStem={addStem}
          onDownload={downloadSession}
          onShare={shareSession}
          onReset={resetSession}
          onChangeIntroLevel={(newValue) => dispatch(setIntroLevel(newValue))}
          onChangeClick1Level={(newValue) => dispatch(setClick1Level(newValue))}
          onChangeClick2Level={(newValue) => dispatch(setClick2Level(newValue))}
          onChangeCueLevel={(newValue) => dispatch(setCueLevel(newValue))}
          step={0.5}
          showGuideChannelButtons={false}
          introLevel={introLevel}
          click1Level={click1Level}
          click2Level={click2Level}
          cueLevel={cueLevel}
        />
      default:
        return <div>No template provided</div>
    }
  }

  const getLoadingText = () => {
    switch (loadingProgress.step) {
      case 0:
        return "Booting session...";
      case 1:
        return "Downloading song";
      case 2:
        return "Downloading song";
      case 3:
        return "Loading song into memory";
      case 4:
        return "Starting engine...";
      case 5:
        return "Ready to roll...";
      case 6:
        return "Packing up session...";
      case 7:
        return "Loading offline render...";
      case 8:
        return "Rendering bounce...";
      case 9:
        return "Creating download...";
      default:
        break;
    }
  };
  // debugLog(stems);
  return status === "ready" && mountedOnce ? (
    <>
      {renderMixer()}
      <Modal
        isOpen={pendingDeleteChannel ? true : false}
        title="Delete channel?"
        text={
          <>
            <span>
              Are you sure you'd like to remove{" "}
              <b>{pendingDeleteChannel.label}</b> from the session and all
              associated recordings that have been made on it?
            </span>
          </>
        }
        confirmLabel="Yes, delete it"
        icon={
          <ExclamationIcon
            className="h-6 w-6 text-primary"
            aria-hidden="true"
          />
        }
        closeLabel="Cancel"
        onClose={() => {
          setPendingDeleteChannel(false);
        }}
        onConfirm={confirmDeleteTrack}
      />
      <Modal
        isOpen={newTrackModalVisible}
        title="New channel"
        content={
          <div className="w-full">
            <p>Please provide a name for the new channel</p>
            <Input
              onChange={(e) => setPendingNewChannelName(e.target.value)}
              placeholder="eg Vocals"
              autofocus
              label="Name"
              size="md"
              type="text"
              className="w-full border rounded-md my-4 p-2"
              autocomplete="off"
            ></Input>
          </div>
        }
        confirmLabel="Add"
        icon={
          <MicrophoneIcon
            className="h-6 w-6 text-primary"
            aria-hidden="true"
          />
        }
        closeLabel="Cancel"
        onClose={() => {
          
          dispatch(setUserInputtingText(false));
        }}
        onConfirm={confirmAddStem}
      />
      <Modal
        isOpen={showHeadphoneWarning ? true : false}
        title="Have you got headphones plugged in?"
        text="You'll want to use headphones while recording to prevent feedback from the speakers"
        confirmLabel="Okay"
        icon={
          <MicrophoneIcon
            className="h-6 w-6 text-primary"
            aria-hidden="true"
          />
        }
        onConfirm={() => setShowHeadphoneWarning(false)}
      />
      <Modal
        isOpen={showRecordArmWarning ? true : false}
        title="No armed tracks"
        text="You'll need to add a track and record arm it to record into this session"
        confirmLabel="Okay"
        icon={
          <MicrophoneIcon
            className="h-6 w-6 text-primary"
            aria-hidden="true"
          />
        }
        onConfirm={() => setShowRecordArmWarning(false)}
      />
    </>
  ) : status === "empty" ? (
    <NoSessionLoaded setlistEnabled={clientConfiguration.features.setlist.enabled} setlistSessions={setlistSessions} />
  ) : (
    <LoadingScreen
      animationFile={clientConfiguration.features.session.loadingAnimationFile}
      title="Loading session"
      text={getLoadingText()}
      loadingProgress={loadingProgress}
      totalSteps={9}
      onCancel={handleCancel}
    />
  );
};

export default Session;
